import { render, staticRenderFns } from "./SettingSum.vue?vue&type=template&id=ed74017c&scoped=true&"
import script from "./SettingSum.vue?vue&type=script&lang=js&"
export * from "./SettingSum.vue?vue&type=script&lang=js&"
import style0 from "./SettingSum.vue?vue&type=style&index=0&id=ed74017c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed74017c",
  null
  
)

export default component.exports